import { userLanguage, ValidLanguages } from '$translations/index';
import { ErrorMessageEn, ErrorMessageEs } from '../../../../constants/alerts';
import { errorHandler } from '../../../utils';
import { CompanyBuilder, LoadCompaniesOutput } from '../companies.types';

export const loadCompanies = (builder: CompanyBuilder) =>
  builder.query<LoadCompaniesOutput, void>({
    query: () => ({
      url: '/companies',
      method: 'GET',
    }),
    providesTags: (result) =>
      result
        ? [
            ...result.map(({ Id }) => ({ type: 'Company' as const, Id })),
            { type: 'Company', Id: 'LIST' },
          ]
        : [{ type: 'Company', Id: 'LIST' }],
    transformErrorResponse: (error) => {
      errorHandler(
        '[setCompanies]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.CompaniesSetError
          : ErrorMessageEn.CompaniesSetError,
        error,
        true
      );
      return error.data;
    },
  });
